// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Courses__Wrapper__2_0fO"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Courses/Courses.css
// module id = 131
// module chunks = 0